// extracted by mini-css-extract-plugin
export default {"title-line-clamp":"NewsCard_title-line-clamp__mbY1F"};